import { WizardProgress } from "./WizardProgress";
import { WizardStepRenderer } from "./WizardStepRenderer";
import { AchievementToast } from "./AchievementToast";
import { ConfettiCelebration } from "./ConfettiCelebration";
import { GamificationSidebar } from "./GamificationSidebar";
import { useOnboardingWizard } from "./OnboardingWizardProvider";

export function OnboardingWizard() {
  const { pendingCelebrations } = useOnboardingWizard();

  return (
    <div className="min-h-[100dvh] bg-muted flex">
      {/* Desktop sidebar - hidden on mobile */}
      <div className="hidden lg:flex lg:w-80 lg:flex-col lg:border-r lg:border-border lg:bg-card">
        <GamificationSidebar />
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col">
        {/* Top progress section */}
        <div className="sticky top-0 z-10 bg-muted/80 backdrop-blur-sm px-4 pt-4 pb-2 sm:px-6">
          <WizardProgress />
        </div>

        {/* Step content - centered */}
        <div className="flex-1 flex items-center justify-center px-4 py-6 sm:px-6">
          <div className="w-full max-w-md">
            <WizardStepRenderer />
          </div>
        </div>
      </div>

      {/* Celebrations */}
      {pendingCelebrations.length > 0 && <ConfettiCelebration />}
      <AchievementToast />
    </div>
  );
}
